var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SummonablePlayerComponent_player_accessor_storage;
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SummonablePlayerComponent = class SummonablePlayerComponent extends LitElement {
    constructor() {
        super(...arguments);
        _SummonablePlayerComponent_player_accessor_storage.set(this, { player: '', moves: [] });
    }
    get player() { return __classPrivateFieldGet(this, _SummonablePlayerComponent_player_accessor_storage, "f"); }
    set player(value) { __classPrivateFieldSet(this, _SummonablePlayerComponent_player_accessor_storage, value, "f"); }
    render() {
        const lastMove = this.player.moves[this.player.moves.length - 1];
        return html `
            <player-canvas class="player" .player=${this.player}></player-canvas>
            <p>${this.player.player}</p>
            <p>Music Layer: ${this.player.songTrack}</p>
        `;
    }
};
_SummonablePlayerComponent_player_accessor_storage = new WeakMap();
SummonablePlayerComponent.styles = css `
        :host {
            background-color: #613b8a;
            border-radius: 10px;
            border: 3px solid black;
            box-shadow: 0 0 30px black;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            margin: 5px;
        }

        .player {
            width: 100%;
        }
    `;
__decorate([
    property({ type: Object })
], SummonablePlayerComponent.prototype, "player", null);
SummonablePlayerComponent = __decorate([
    customElement('summonable-player')
], SummonablePlayerComponent);
export { SummonablePlayerComponent };
